// Wrapper frontend pour CarQuery API, via le proxy backend /api/cars/*.
//
// CarQuery est gratuit et sans clé mais expose ses endpoints en JSONP
// uniquement → on passe par le backend antennes qui parse et renvoie
// du JSON pur. Cache localStorage 7j côté frontend pour limiter les
// appels lors de la navigation.

import api from '../services/api';

// v3 : bump pour invalider les valeurs cachées des versions précédentes
// (incl. v1 v2 qui pouvaient contenir des listes vides ou stale)
const CACHE_PREFIX = 'carquery-v3:';
const CACHE_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 jours

function readCache(key) {
  try {
    const raw = localStorage.getItem(CACHE_PREFIX + key);
    if (!raw) return null;
    const { ts, data } = JSON.parse(raw);
    if (Date.now() - ts > CACHE_TTL_MS) return null;
    return data;
  } catch { return null; }
}
function writeCache(key, data) {
  try { localStorage.setItem(CACHE_PREFIX + key, JSON.stringify({ ts: Date.now(), data })); }
  catch { /* ignore quota */ }
}

// Liste des marques. Si `year` est fourni, restreint aux marques disponibles cette année-là.
export async function fetchAllMakes(year = null) {
  const key = `makes:${year || 'all'}`;
  const cached = readCache(key);
  if (cached) return cached;

  const params = year ? { year } : {};
  const res = await api.get('/cars/makes', { params });
  const makes = res.data?.data || [];
  // Cache uniquement si non vide pour ne pas figer une mauvaise réponse
  if (makes.length > 0) writeCache(key, makes);
  return makes;
}

// Modèles pour une marque, optionnellement filtrés par année.
export async function fetchModelsForMake(make, year = null) {
  if (!make) return [];
  const key = `models:${make.toUpperCase()}:${year || 'all'}`;
  const cached = readCache(key);
  if (cached) return cached;

  const params = { make };
  if (year) params.year = year;
  const res = await api.get('/cars/models', { params });
  const models = res.data?.data || [];
  if (models.length > 0) writeCache(key, models);
  return models;
}

// Alias pour préserver l'interface existante (compat avec l'ancien nhtsa.js)
export const fetchModelsForMakeYear = (make, year) => fetchModelsForMake(make, year);

// Liste d'années (de l'année courante + 1 à 1990)
export function getYearRange() {
  const current = new Date().getFullYear() + 1;
  const years = [];
  for (let y = current; y >= 1990; y--) years.push(y);
  return years;
}
